/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
/**
 * To download the file from the given sasUri
 *
 * @param sasUri string
 */
interface DownloadResult {
  status: "success" | "failed";
  error?: any;
}

export const downloadFile = async (
  sasUri: string,
  fileToDownload: string
): Promise<DownloadResult> => {
  try {
    const response = await fetch(sasUri, {
      method: "GET"
    });

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileToDownload;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return { error: null, status: "success" };
  } catch (error: any) {
    return { error: error?.message || "Failed to download file", status: "failed" };
  }
};
